var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_17279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3817 21.991V0.605469C9.92658 1.20632 0.596942 10.5359 -0.00390625 21.991H21.3817ZM16.6469 18.4399H14.2794V16.0725H16.6469V18.4399ZM9.54464 11.3377H11.912V13.7051H9.54464V11.3377ZM15.4632 10.8476L17.137 12.5214L10.7283 18.9301L9.0545 17.2562L15.4632 10.8476Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.382 24.3584H7.22266C7.79951 31.9022 13.8382 37.9409 21.382 38.5178V24.3584H21.382Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 5.33984C23.75 5.5941 23.75 41.2883 23.75 41.0088C32.9886 40.3952 40.4008 32.4475 40.4008 23.0561C40.4008 13.6639 32.9908 5.95135 23.75 5.33984ZM30.8522 21.9906C32.8104 21.9906 34.4034 23.5836 34.4034 25.5417C34.4034 27.0829 33.4108 28.3845 32.0359 28.8748V31.4602H29.6685V28.8748C28.2937 28.3845 27.3011 27.0829 27.3011 25.5417H29.6685C29.6685 26.1948 30.1991 26.7254 30.8522 26.7254C31.5053 26.7254 32.0359 26.1948 32.0359 25.5417C32.0359 24.8886 31.5053 24.358 30.8522 24.358C28.8941 24.358 27.3011 22.7651 27.3011 20.8069C27.3011 19.2657 28.2937 17.9641 29.6685 17.4738V14.8884H32.0359V17.4738C33.4108 17.9641 34.4034 19.2657 34.4034 20.8069H32.0359C32.0359 20.1538 31.5053 19.6232 30.8522 19.6232C30.1991 19.6232 29.6685 20.1538 29.6685 20.8069C29.6685 21.46 30.1991 21.9906 30.8522 21.9906Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_17279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.4054,
    height: 40.4054,
    fill: "white",
    transform: "translate(-0.00390625 0.606445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/Payment_icon.4faf2c7e914d1da3692107b443ae4774.svg";
export { ForwardRef as ReactComponent };